export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7942.dc990d28.jpg";